import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
} from '@mui/material';

const Terms = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        py: 4,
      }}
    >
      <Container component="main" maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            padding: 4,
            backgroundColor: '#ffffff',
          }}
        >
          <Typography
            component="h1"
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: '#000000',
              marginBottom: 3,
            }}
          >
            이용약관
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
              }}
            >
              {`제1조 (목적)
이 약관은 planGo (이하 "회사"라 함)이 제공하는 서비스의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.

제2조 (정의)
① "서비스"란 회사가 제공하는 회원이 설정한 조건에 따라 주문 실행을 보조하는 시스템 제공 서비스를 의미하며, 투자 판단에 대한 책임은 전적으로 회원에게 있습니다. 회사는 개별 종목, 매매 시점, 가격 등에 대하여 어떠한 투자 판단도 제공하지 않습니다.
② "이용자"란 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 의미합니다.
③ "회원"이란 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 정보를 지속적으로 제공받으며, 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 의미합니다.

제3조 (약관의 게시와 개정)
① 회사는 이 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.
② 회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
③ 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스의 초기화면에 그 적용일자 30일 이전부터 적용일자 전일까지 공지합니다.

제4조 (회원가입)
① 이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.
② 회사는 제1항과 같이 회원가입을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
  1. 가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우
  2. 등록 내용에 허위, 기재누락, 오기가 있는 경우
  3. 기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우

제5조 (회원정보의 변경)
회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 이메일 등은 수정이 불가능합니다.

제6조 (서비스의 제공 및 변경)
① 회사는 다음과 같은 서비스를 제공합니다.
  1. 주문 실행 보조
  2. 관심종목 관리 서비스
  3. 기타 회사가 추가 개발하거나 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스
② 회사는 필요한 경우 서비스의 내용을 변경할 수 있으며, 이 경우에는 변경된 서비스의 내용 및 제공일자를 명시하여 현재의 서비스의 내용을 게시한 곳에 즉시 공지합니다.

제7조 (서비스의 중단)
① 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.
② 서비스 중단으로 인하여 발생한 회원의 손해에 대하여 회사는 고의 또는 중과실이 없는 한 책임을 지지 않습니다.

제8조 (회원의 의무)
① 회원은 다음 행위를 하여서는 안 됩니다.
  1. 신청 또는 변경 시 허위내용의 등록
  2. 타인의 정보 도용
  3. 회사가 게시한 정보의 변경
  4. 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시
  5. 회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해
  6. 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
  7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위

제9조 (개인정보보호)
① 회사는 이용자의 개인정보 수집시 서비스제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.
② 회사는 회원가입시 구매계약이행에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을 위하여 필요한 경우에는 예외로 합니다.
③ 회사는 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 이용·제공단계에서 당해 회원에게 그 목적을 고지하고 동의를 받습니다.
④ 개인정보의 처리에 관한 상세한 사항은 회사의 개인정보처리방침에 따릅니다.

제10조 (면책조항)
① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
② 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.
③ 회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.
④ 회사는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도 및 정확성에 대하여 책임을 지지 않습니다.
본 서비스는 투자 참고용 도구이며, 회사는 특정 수익을 보장하지 않습니다.
모든 투자 판단 및 그 결과에 대한 책임은 회원 본인에게 있습니다. 시스템 오류, 증권사 API 장애, 통신 장애로 인한 주문 지연 또는 실패 포함


제11조 (준거법 및 관할법원)
① 회사와 이용자 간에 발생한 분쟁에 관한 소송은 민사소송법에 따른 관할 법원에 제기합니다.

부칙
이 약관은 2025년 12월 21일부터 시행됩니다.`}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
            <Button
              variant="contained"
              onClick={() => window.close()}
              sx={{
                backgroundColor: '#000000',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#333333',
                },
              }}
            >
              닫기
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Terms;

